// ─────────────────────────────────────────────────────────────────────────────
// useConsent.ts
// Hoy Toca Recetas — Grupo Herdez
//
// Hook de acceso al ConsentContext.
// Lanza un error claro si se usa fuera del ConsentProvider.
// ─────────────────────────────────────────────────────────────────────────────

import { useContext } from 'react';
import { ConsentContext, ConsentContextValue } from '../contexts/ConsentContext';

/**
 * Accede al estado y las acciones de consentimiento de cookies.
 *
 * @example
 * const { consent, acceptAll } = useConsent();
 * if (consent.analytics) trackEvent('view_recipe');
 */
export function useConsent(): ConsentContextValue {
  const ctx = useContext(ConsentContext);

  if (!ctx) {
    throw new Error(
      '[HoyToca] useConsent debe usarse dentro de <ConsentProvider>.\n' +
      'Asegúrate de que ConsentProvider envuelve el árbol en src/index.tsx.',
    );
  }

  return ctx;
}
